export default __webpack_public_path__ + "images/phpx_57d68a.png";